import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import {
  setFamilyMembers,
  getFamilyMembers,
  updateFamilyMember,
  deleteFamilyMember,
} from '../../actions/familyMembersActions';
// Add this near other imports (line 12 के पास)
import { sendConfirmationSms } from '../../actions/smsActions';
import MessageModal from '../Pages/MessageModel';
import { Link } from 'react-router-dom'; 
const AddFamilyMembers = () => {
  const dispatch = useDispatch();
  const familyState = useSelector((state) => state.familyMembers);
  const hospitalID = localStorage.getItem('hospitalCode') || '';

  // Safely extract members from redux state
  const familyMembers = Array.isArray(familyState?.members?.data) ? familyState.members.data : [];

  const [members, setMembers] = useState([
    { firstName: '', lastName: '', dateOfBirth: '', gender: '', relation: '', id: null },
  ]);
  const [loading, setLoading] = useState(false);
  const [operationInProgress, setOperationInProgress] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalMessage, setModalMessage] = useState('');
  const [modalVariant, setModalVariant] = useState('info');

  const formatBackendDate = (dateStr) => {
    if (!dateStr) return '';
    try {
      if (dateStr.includes('/')) {
        const parts = dateStr.split('/');
        const year = parts[2].length === 2 ? 2000 + parseInt(parts[2], 10) : parseInt(parts[2], 10);
        const date = new Date(year, parts[0] - 1, parts[1]);
        return isNaN(date) ? '' : date.toISOString().slice(0, 10);
      }
      const date = new Date(dateStr);
      return isNaN(date) ? '' : date.toISOString().slice(0, 10);
    } catch {
      return '';
    }
  };

  const formatForBackend = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    if (isNaN(date)) return '';
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear().toString().slice(-2)}`;
  };
useEffect(() => {
  if (hospitalID && !operationInProgress) {
    dispatch(getFamilyMembers({ PatientID: hospitalID })); 
  }
}, [dispatch, hospitalID, operationInProgress]);
  // useEffect(() => {
  //   if (hospitalID && !operationInProgress) {
  //     dispatch(getFamilyMembers(hospitalID));
  //   }
  // }, [dispatch, hospitalID, operationInProgress]);

  useEffect(() => {
    if (familyMembers.length > 0) {
      const formatted = familyMembers.map((m) => ({
        firstName: m.firstName || '',
        lastName: m.lastName || '',
        dateOfBirth: formatBackendDate(m.dateOfBirth),
        gender: m.gender || '',
        relation: m.relation || '',
        id: m.id || null,
      }));
      const isSame = members.length === formatted.length && members.every((m, i) => m.id === formatted[i].id);
      if (!isSame) {
        setMembers(formatted);
      }
    } else if (members.length === 0) {
      setMembers([{ firstName: '', lastName: '', dateOfBirth: '', gender: '', relation: '', id: null }]);
    }
  }, [familyMembers]);

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    setMembers((prev) => {
      const copy = [...prev];
      copy[index] = { ...copy[index], [name]: value };
      return copy;
    });
  };

  const addMember = () => {
    if (operationInProgress) return;
    setMembers((prev) => [...prev, { firstName: '', lastName: '', dateOfBirth: '', gender: '', relation: '', id: null }]);
  };

  const removeMember = async (index) => {
    if (operationInProgress) return;
    const member = members[index];
    if (member.id) {
      
      try {
        const payload = { id: member.id, PatientID: parseInt(hospitalID, 10) };
        const res = await dispatch(deleteFamilyMember(payload));
        const success = Array.isArray(res)
          ? res.some((r) => r?.success === 1 || r?.SUCCESS === 1)
          : res?.success === 1 || res?.SUCCESS === 1;
        if (success) {
          const message = Array.isArray(res) ? res[0]?.message : res?.message;
          dispatch(getFamilyMembers({ PatientID: hospitalID }));
        } else {
          const message = Array.isArray(res) ? res[0]?.message : res?.message;
          dispatch(getFamilyMembers({ PatientID: hospitalID }));

        }
      } catch {
        dispatch(getFamilyMembers({ PatientID: hospitalID }));

      } finally {
        setLoading(false);
        setTimeout(() => setOperationInProgress(false), 500);
      }
    } else {
      setMembers((prev) => prev.filter((_, idx) => idx !== index));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (operationInProgress) return;
    setOperationInProgress(true);
    setLoading(true);
    const loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
    const pid = parseInt(hospitalID, 10);
    if (isNaN(pid)) {
      dispatch(getFamilyMembers({ PatientID: hospitalID }));

      setLoading(false);
      setOperationInProgress(false);
      return;
    }

    let successCount = 0;
    let errorCount = 0;

    const newMembers = [];
    const updatedMembers = [];

    members.forEach((member) => {
      const processed = { ...member, PatientID: pid, dateOfBirth: formatForBackend(member.dateOfBirth) };
      const valid = processed.firstName.trim() && processed.lastName.trim() && processed.relation.trim();
      if (!valid) {
        if (member.id) updatedMembers.push(processed);
        return;
      }
      if (member.id) updatedMembers.push(processed);
      else newMembers.push(processed);
    });

    // Helper functions
    const isSuccess = (res) => {
      if (Array.isArray(res)) return res.some(r => r?.success === 1 || r?.SUCCESS === 1);
      return res?.success === 1 || res?.SUCCESS === 1;
    };
    const getMessage = (res) => {
      const obj = Array.isArray(res) ? res[0] : res;
      return obj?.message || obj?.messages || 'Operation complete';
    };

    for (const nm of newMembers) {
      try {
        const res = await dispatch(setFamilyMembers([nm]));
        if (isSuccess(res)) successCount++;
         if (loginData?.mobile) {
        const smsPayload = {
          hid: "2",
          recipientPhone: loginData.mobile, // पेशेंट का नंबर
          eventId: "MEDISEVAS_APP_PATIENT_FAMILYMEMBER_ADDED",
          templateData: {
            relationship: nm.relation, // जैसे: Spouse, Child
            memberName: `${nm.firstName} ${nm.lastName}` // सदस्य का नाम
          }
        };
        dispatch(sendConfirmationSms(smsPayload));
      }
        else errorCount++;
      } catch {
        errorCount++;
      }
    }

    for (const um of updatedMembers) {
      try {
        const res = await dispatch(updateFamilyMember(um));
        if (isSuccess(res)) {
          if (res.info && res.info.includes('Changed: 0')) {
            dispatch(getFamilyMembers({ PatientID: hospitalID }));

          } else {
           dispatch(getFamilyMembers({ PatientID: hospitalID }));

          }
          successCount++;
        } else {
          errorCount++;
          dispatch(getFamilyMembers({ PatientID: hospitalID }));

        }
      } catch {
        errorCount++;
        dispatch(getFamilyMembers({ PatientID: hospitalID }));

      }
    }

    if (successCount && !errorCount) {
      // Already notified success per member
    } else if (successCount && errorCount) {
      dispatch(getFamilyMembers({ PatientID: hospitalID }));
    } else if (!successCount && errorCount) {
      dispatch(getFamilyMembers({ PatientID: hospitalID }));

    } else if (!successCount && !errorCount) {
     dispatch(getFamilyMembers({ PatientID: hospitalID }));

    }

   dispatch(getFamilyMembers({ PatientID: hospitalID }));

    setLoading(false);
    setTimeout(() => setOperationInProgress(false), 600);
  };

  return (
    <div className="">
      <Helmet>
        <title>Family Members | Medisvas</title>
        <meta name="description" content="Manage your family members' health records." />
      </Helmet>
       <div className="page-header filter-bar rounded ">
                <div className="row align-items-center">
                    <div className="col">
                        <h4 className="page-title">Family-members</h4>
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/doctor/dashboard">Patient Dashboard</Link></li>
                            <li className="breadcrumb-item active">Family-members</li>
                        </ul>
                    </div>
                </div>
      </div>
      <form onSubmit={handleSubmit}>
        {members.map((member, idx) => (
          <div key={member.id || idx} className="member-section mb-4 p-3 border rounded">
            <div className=" d-flex justify-content-between align-items-center mb-3">
              <h5>
                Family Member #{idx + 1}
                {member.id && <small className="text-muted"> (ID: {member.id})</small>}
              </h5>
              <button type="button" className='i-btn-delete' disabled={loading || operationInProgress} onClick={() => removeMember(idx)} title='Delete Family Member'>
                
              </button>
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label>First Name *</label>
                <input type="text" name="firstName" value={member.firstName} onChange={e => handleChange(idx, e)} className="form-control" required disabled={loading || operationInProgress} />
              </div>
              <div className="col-md-6 mb-3">
                <label>Last Name *</label>
                <input type="text" name="lastName" value={member.lastName} onChange={e => handleChange(idx, e)} className="form-control" required disabled={loading || operationInProgress} />
              </div>
              <div className="col-md-6 mb-3">
                <label>Date of Birth</label>
                <input type="date" name="dateOfBirth" value={member.dateOfBirth} onChange={e => handleChange(idx, e)} className="form-control" disabled={loading || operationInProgress} />
              </div>
              <div className="col-md-6 mb-3">
                <label>Gender</label>
                <select name="gender" value={member.gender} onChange={e => handleChange(idx, e)} className="form-control" disabled={loading || operationInProgress}>
                  <option value="">Select Gender</option>
                  <option>Male</option>
                  <option>Female</option>
                  <option>Other</option>
                </select>
              </div>
              <div className="col-md-6 mb-3">
                <label>Relation *</label>
                <select name="relation" value={member.relation} onChange={e => handleChange(idx, e)} className="form-control" required disabled={loading || operationInProgress}>
                  <option value="">Select Relation</option>
                  <option>Spouse</option>
                  <option>Child</option>
                  <option>Parent</option>
                  <option>Sibling</option>
                  <option>Grandparent</option>
                  <option>Grandchild</option>
                  <option>Other</option>
                </select>
              </div>
            </div>
          </div>
        ))}
        <button 
          type="button" 
          className="btn btn-success rounded-pill mr-2 mb-3 d-inline-flex align-items-center" 
          disabled={loading || operationInProgress} 
          onClick={addMember}
        >
          <img 
            src="/assets/img/add-user.png" 
            alt="add-user" 
            style={{ width: '16px', height: '16px', marginRight: '5px' }} 
          />
          Add Another Member
        </button>
        <button  className="btn btn-info rounded-pill sm mb-3" disabled={loading || operationInProgress}>
          {loading ? 'Saving...' : 'Update Members'}
        </button>
      </form>

     
    </div>
  );
};

export default AddFamilyMembers;
